import React, {Component} from 'react'
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import Login from '../components/Login'
import {forgottenPassword, sessionLogin} from "../actions/session"
import {resetAlerts} from "../actions"

const loadData = props => {
};

class LoginPage extends Component {

	// constructor(props) {
	// 	super(props)
	// }

	componentWillMount() {
		loadData(this.props);
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
	}

	render() {
		const {sessionLogin, forgottenPassword, session} = this.props;
		return (
			<Login
				onLogin={sessionLogin}
				onForgottenPassword={forgottenPassword}
				session={session}
				params={this.props.match.params}
			/>
		)
	}
}

LoginPage.propTypes = {
	sessionLogin: PropTypes.func.isRequired,
	forgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	alerts: PropTypes.object.isRequired,
	resetAlerts: PropTypes.func.isRequired,
	// Injected by React Router
	children: PropTypes.node
};

const mapStateToProps = (state, ownProps) => ({
	alerts: state.alerts,
	session: state.session,
});

export default connect(mapStateToProps, {
	sessionLogin,
	forgottenPassword,
	resetAlerts
})(LoginPage)


// WEBPACK FOOTER //
// ./src/containers/LoginPage.js